import { useState } from 'react'
import { getUserByEmail, getUserByNameOrCPF } from '../services/user'
import { validateEmail } from '../utils/functionalitiesHelper'

export const useGetTutor = () => {
  const [user, setUser] = useState([])
  const [loading, setLoading] = useState(false)
  const [total, setTotal] = useState(0)

  const reset = () => {
    setUser([])
    setTotal(0)
  }

  const getTutor = async (userData, from = 0, to = 8) => {
    const hasInput = userData.length > 0
    setLoading(true)
    if (!hasInput) {
      setUser([])
      setTotal(0)
      setLoading(false)
      return
    }
    const isValidEmail = validateEmail(userData)
    if (isValidEmail) {
      const users = await getUserByEmail(userData)
      setUser(users)
      setTotal(users.length)
      setLoading(false)
      return
    }
    const users = await getUserByNameOrCPF(userData, from, to)
    setUser(users)
    setTotal(users.length)
    setLoading(false)
  }

  return {
    user,
    total,
    loading,
    reset,
    getTutor
  }
}
